import baseStore from '../generic_store'

const base = baseStore('pages');

const state = {
    ...base.state,
    base_url: '/api/pages',
    resourceName: 'Page(s)',
    model: {},
};

const getters = {
    ...base.getters,
};

const mutations = {
    ...base.mutations,
};

const actions = {
    ...base.actions,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
